(() => {
  if (window.CelvianProductMedia) return;
  const instances = new Map();
  window.CelvianProductMedia = {
    mount(scope) {
      const $ = window.jQuery;
      const nav = scope.querySelector('[data-celvian-product-media]');
      if (!nav || instances.has(nav)) return;
      const $nav = $(nav);
      const $thumbs = $(scope).find('.productView-for');
      const slides = Array.from(nav.children);
      const counter = scope.querySelector('[data-celvian-media-counter]');
      const zoom = scope.querySelector('.productView-iconZoom');
      const mobile = matchMedia('(max-width: 767px)');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const abort = new AbortController();
      let currentId = nav.dataset.initialMedia;
      let lastFilter;
      let thumbsFilter = '';

      const mediaId = slide => slide?.querySelector('[data-media-id]')?.dataset.mediaId;
      const pause = () => {
        scope.querySelectorAll('[data-celvian-video]').forEach(container => {
          container.querySelector('video')?.pause();
          const frame = container.querySelector('[data-celvian-player] iframe');
          if (frame) {
            frame.parentElement.remove();
            container.querySelector('[data-celvian-video-play]').hidden = false;
          }
        });
      };
      const activate = (container, autoplay) => {
        let player = container.querySelector('[data-celvian-player]');
        if (!player) {
          player = document.createElement('div');
          player.dataset.celvianPlayer = '';
          const content = container.querySelector('template').content.cloneNode(true);
          const frame = content.querySelector('iframe');
          if (frame && !autoplay) {
            const url = new URL(frame.src);
            url.searchParams.set('autoplay', '0'); frame.src = url.href;
          }
          container.append(player);
          player.append(content);
        }
        const play = container.querySelector('[data-celvian-video-play]');
        play.hidden = true;
        const video = player.querySelector('video');
        if (!autoplay) { if (video) video.preload = 'metadata'; return; }
        const target = video || player.querySelector('iframe');
        if (target) { target.tabIndex = 0; target.focus({preventScroll: true}); }
        if (video) video.play().catch(() => { play.hidden = false; });
      };
      const update = (event, instance) => {
        const slick = instance || (nav.classList.contains('slick-initialized') ? nav.slick : null);
        const slide = slick ? slick.$slides[slick.currentSlide] : nav.firstElementChild;
        if (mobile.matches && slide) currentId = mediaId(slide);
        nav.toggleAttribute('tabindex', mobile.matches);
        if (mobile.matches) {
          nav.tabIndex = 0;
          nav.setAttribute('role', 'region');
          nav.setAttribute('aria-label', counter?.querySelector('.visually-hidden')?.textContent.trim() || '');
          nav.querySelector('.slick-list')?.setAttribute('aria-live', 'off');
          nav.querySelectorAll('.slick-slide').forEach(item => {
            item.querySelectorAll('a,button,video,iframe').forEach(control => { control.tabIndex = item === slide ? 0 : -1; });
          });
        } else {
          nav.removeAttribute('role'); nav.removeAttribute('aria-label');
          nav.querySelectorAll('a,button,video,iframe').forEach(control => control.removeAttribute('tabindex'));
          if (zoom) zoom.hidden = false;
        }
        if (counter) {
          const total = slick?.slideCount || nav.children.length;
          counter.hidden = total < 2;
          counter.querySelector('[data-media-current]').textContent = (slick?.currentSlide || 0) + 1;
          counter.querySelector('[data-media-total]').textContent = total;
        }
        if (zoom && mobile.matches) zoom.hidden = !slide?.querySelector('[data-fancybox]');
      };
      const selector = () => {
        if (nav.dataset.variantGroup !== 'true') return '';
        const input = scope.querySelector('input[data-filter]:checked');
        if (!input) return '';
        const metadata = $(input).data('metafields-vig');
        if (metadata?.length) return (Array.isArray(metadata) ? metadata : metadata.split(',')).map(value => '.filter-' + value.toLowerCase().replace(/[^A-Z0-9]/ig, '-')).join(',');
        const options = scope.querySelector('.productView-options');
        if (options?.dataset.lang !== options?.dataset.defaultLang && input.dataset.valueDefaultLang) return '.filter-' + input.dataset.valueDefaultLang;
        return input.dataset.filter || '';
      };
      const syncThumbs = () => {
        if (!$thumbs.hasClass('slick-initialized')) return;
        const filter = nav.classList.contains('media-filter') ? lastFilter : '';
        if (filter !== thumbsFilter) {
          if (thumbsFilter) $thumbs.slick('slickUnfilter');
          if (filter) $thumbs.slick('slickFilter', filter);
          thumbsFilter = filter;
        }
        $thumbs.slick('slickSetOption', 'asNavFor', mobile.matches ? $nav : false, false);
        $thumbs.slick('slickSetOption', 'waitForAnimate', false, false);
      };
      const render = (force = false) => {
        const filter = selector();
        if (!force && filter === lastFilter) return;
        lastFilter = filter;
        pause();
        if (mobile.matches) slides.forEach(slide => slide.querySelectorAll('[data-celvian-zoom]').forEach(media => {
          $(media).trigger('zoom.destroy'); delete media.dataset.celvianZoom;
        }));
        if (nav.classList.contains('slick-initialized')) $nav.slick('unslick');
        $(nav.children).detach();
        let visible = slides;
        if (filter) {
          try {
            const matches = slides.filter(slide => slide.matches(filter));
            if (matches.length) visible = matches;
          } catch (_) { visible = slides; }
        }
        visible.forEach(slide => nav.append(slide));
        nav.classList.toggle('media-filter', Boolean(filter && visible.length !== slides.length));
        if (mobile.matches) {
          let initial = visible.findIndex(slide => mediaId(slide) === String(currentId));
          if (initial < 0) initial = 0;
          $nav.slick({
            fade: false, dots: false, arrows: false, infinite: false,
            slidesToShow: 1, slidesToScroll: 1, initialSlide: initial,
            asNavFor: $thumbs, speed: motion.matches ? 0 : 240,
            swipe: true, touchMove: true, touchThreshold: 8,
            waitForAnimate: false,
            adaptiveHeight: false, accessibility: false, rtl: window.rtl_slick
          });
        } else {
          visible.forEach(slide => slide.querySelectorAll('[data-celvian-video]').forEach(container => activate(container, false)));
        }
        syncThumbs();
        update();
      };
      $nav.on('init.celvianMedia reInit.celvianMedia afterChange.celvianMedia', update);
      $nav.on('beforeChange.celvianMedia', pause);
      $nav.on('celvian:media-select.celvianMedia', (event, id) => {
        if (!mobile.matches || !id) return;
        currentId = String(id);
        render();
        if (!nav.classList.contains('slick-initialized')) return;
        const slick = $nav.slick('getSlick');
        const index = slick.$slides.toArray().findIndex(slide => mediaId(slide) === currentId);
        if (index >= 0 && index !== slick.currentSlide) $nav.slick('slickGoTo', index, motion.matches);
      });
      $(scope).on('click.celvianMedia', '.productView-thumbnail[data-media-id]', event => {
        if (!mobile.matches) return;
        const prefixed = event.currentTarget.dataset.mediaId;
        const id = slides.map(mediaId).find(id => prefixed === id || prefixed.endsWith('-' + id));
        if (id) $nav.trigger('celvian:media-select', [id]);
      });
      $thumbs.on('init.celvianMedia', () => queueMicrotask(syncThumbs));
      nav.addEventListener('keydown', event => {
        if (!mobile.matches || event.target !== nav || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') $nav.slick('slickGoTo', event.key === 'Home' ? 0 : nav.slick.slideCount - 1);
        else $nav.slick(event.key === 'ArrowRight' !== Boolean(window.rtl_slick) ? 'slickNext' : 'slickPrev');
      }, {signal: abort.signal});
      scope.addEventListener('change', event => {
        if (event.target.matches('input[data-filter]')) render();
      }, {signal: abort.signal});
      scope.addEventListener('click', event => {
        const play = event.target.closest('[data-celvian-video-play]');
        if (!play) return;
        event.preventDefault();
        pause();
        const container = play.closest('[data-celvian-video]');
        activate(container, true);
      }, {signal: abort.signal});
      scope.addEventListener('pointerover', event => {
        const media = event.target.closest('[data-zoom-image]');
        if (!media || window.innerWidth <= 1024 || media.dataset.celvianZoom) return;
        media.dataset.celvianZoom = 'true';
        $(media).zoom({url: media.dataset.zoomImage, touch: false, callback() {
          if (media.matches(':hover')) $(media).trigger($.Event('mouseenter.zoom', {pageX: event.pageX, pageY: event.pageY}));
        }});
      }, {signal: abort.signal});
      const breakpoint = () => render(true);
      const preference = () => { if (nav.classList.contains('slick-initialized')) $nav.slick('slickSetOption', 'speed', motion.matches ? 0 : 240, false); };
      mobile.addEventListener('change', breakpoint);
      motion.addEventListener('change', preference);
      document.addEventListener('visibilitychange', () => { if (document.hidden) pause(); }, {signal: abort.signal});
      window.addEventListener('pagehide', pause, {signal: abort.signal});
      const observer = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) pause(); });
      observer.observe(nav);
      render(true);
      instances.set(nav, () => {
        pause(); abort.abort(); observer.disconnect();
        slides.forEach(slide => slide.querySelectorAll('[data-celvian-zoom]').forEach(media => {
          $(media).trigger('zoom.destroy'); delete media.dataset.celvianZoom;
        }));
        mobile.removeEventListener('change', breakpoint);
        motion.removeEventListener('change', preference);
        $nav.off('.celvianMedia'); $thumbs.off('.celvianMedia');
        $(scope).off('.celvianMedia');
        if (nav.classList.contains('slick-initialized')) $nav.slick('unslick');
        $(scope).find('.productView-for.slick-initialized').slick('unslick');
        instances.delete(nav);
      });
    }
  };
  document.addEventListener('shopify:section:unload', event => {
    for (const [nav, cleanup] of instances) if (event.target.contains(nav)) cleanup();
  });
})();
